module.exports = __webpack_public_path__ + "img/gn_05.74df0eda.png";